import ApiClient from 'services/apiClient';
import { MultiLanguageField } from 'types/common';

export type CustomPageDTO = {
  id: string;
  cover: MultiLanguageField;
  title: MultiLanguageField;
  content?: MultiLanguageField;
};

export const fetchTips = async (): Promise<CustomPageDTO> => {
  const response = await ApiClient.getInstance().get({
    url: '/common/getcustompagebyid',
    params: { id: 'Laundry-Tips' },
  });

  return response.data;
};
